<template>
  <div style="margin: 15px 30px 0">
    <el-table :data="healths" style="width: 100%">
      <el-table-column label="检查地址" width="320">
        <template #default="scope">
          <el-link type="primary" :underline="false" :href="scope.row.url" target="_blank">
            {{ scope.row.url }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="服务器名称" width="120">
        <template #default="scope">
          {{ scope.row.nodeName }}
        </template>
      </el-table-column>
      <el-table-column label="实例名称" width="120">
        <template #default="scope">
          {{ scope.row.hostName }}
        </template>
      </el-table-column>
      <el-table-column label="检查时间" width="140">
        <template #default="scope">
          {{ scope.row.createdDate }}
        </template>
      </el-table-column>
      <el-table-column label="返回错误">
        <template #default="scope">
          {{ scope.row.errorMessage }}
        </template>
      </el-table-column>
    </el-table>

    <el-divider></el-divider>

    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click.prevent="btnDeleteAllClick">删除全部</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import api from '@/api/admin/healths';
import utils from '@/utils';
import { IHealth } from '@/types/models';

interface IState {
  healths: IHealth[];
}

export default defineComponent({
  name: 'Healths',
  data() {
    return {
      healths: [],
    } as IState;
  },
  methods: {
    apiGet() {
      api.get((res) => {
        if (!res) return;
        this.healths = res.healths;
      });
    },

    apiDelete() {
      api.delete((res) => {
        if (!res) return;
        utils.success('健康检查删除成功！');
        this.apiGet();
      });
    },

    btnDeleteAllClick() {
      utils.alertDelete(
        {
          title: '删除全部健康检查',
          text: '此操作将删除全部健康检查，确定吗？',
          button: '确认删除',
        },
        () => {
          this.apiDelete();
        },
      );
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
